import styled, { css } from 'styled-components';
import * as InputStyles from '../Input/styles';

type ContainerProps = {
  hasResults?: boolean;
  fullWidth?: boolean;
  rounded?: boolean;
};

const modifiersInputWrapper = {
  fullWidth: () => css`
    border-radius: 8px;
  `,
  rounded: () => css`
    border-radius: 28px;
  `
};

export const Container = styled.div<ContainerProps>`
  ${({ hasResults, fullWidth, rounded }) => css`
    position: relative;
    height: 58px;

    .input-wrapper {
      position: absolute;
      z-index: 5;
      width: 100%;
      box-shadow: ${hasResults || fullWidth ? '0px 5px 6px -2px #00000014;' : 'none'};
    }

    ${InputStyles.InputWrapper} {
      border-radius: 8px;
      border: ${fullWidth ? 0 : '1px solid #d5d5d6;'};
      ${fullWidth && modifiersInputWrapper.fullWidth()}
      ${rounded && modifiersInputWrapper.rounded()}
    }

    ${InputStyles.CustomInput} {
      ${rounded && modifiersInputWrapper.rounded()}
    }

    ${Results} {
      box-shadow: ${fullWidth ? 'none' : '0px 5px 6px -2px #00000014'};
    }

    ${InputStyles.IconWrapper} {
      margin-right: ${fullWidth ? '0' : '0 10px'};
      padding-left: ${fullWidth ? '0' : '16px'};
    }

    ${ResultName} {
      padding: ${fullWidth ? '15px 32px' : '15px 20px'};
    }

    ${InputStyles.InputWrapper} {
      padding: ${fullWidth ? '0 32px' : '0'};
    }

    .loading-wrapper {
      padding-top: 3rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `}
`;

export const Results = styled.ul`
  padding: 0;
  position: absolute;
  background-color: #fff;
  width: 100%;
  margin: 10px 0;
  padding-top: 56px;
  list-style: none;
  box-shadow: 0px 5px 6px -2px #00000014;
`;

export const ResultName = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;

  cursor: pointer;

  p {
    color: var(--blue-einstein);
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    margin-right: 16px;
  }

  img {
    width: 24px;
    height: 24px;
  }
`;
